
import shrink from '~/ZenOne-StoryBook/mixins/shrink.js'

export default {
  name: 'DialogFormConnectDistributors',
  mixins: [shrink],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      fakePassword: null,
      fakeEmail: null,
      focusEmail: false,
      labelEmail: false,
      focusPassword: false,
      labelPassword: false,
      errorEmail: false,
      errorPassword: false,
      valid: false,
      show: false,
      email: null,
      password: null,
      passwordRules: [(v) => !!v || 'Password is required'],
      loginRules: [(v) => !!v || 'Login is required'],
      repNameRules: [v => (!!v || !this.addMyRep) ? true : 'Rep name is required'],
      repEmailRules: [v => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || 'Rep email is invalid'],
      repPhoneRules: [v => v?.length === 17 || 'Rep phone number is invalid'],
      loading: false,
      addMyRep: false,
      sendToRep: false,
      repName: '',
      repPhone: '',
      repEmail: '',
    }
  },
  computed: {
    statusIsActive() {
      return this?.item?.status === 'active'
    },
    statusIsFailed() {
      return this?.item?.status === 'failed'
    },
    isHavingRelation() {
      return this.statusIsActive || this.statusIsFailed
    },
    showFakeInputs() {
      return !this.isHavingRelation
    },
  },
  watch: {
    email(v) {
      this.labelEmail = !!v
    },
    password(v) {
      this.labelPassword = !!v
    },
  },
  async mounted() {
    if (this.isHavingRelation) {
      this.loading = true
      await this.onFetchLoginPass(this.item.practiceLocationDistributorId)
      this.addMyRep = !!this.item.repData
      this.repName = this.item.repData?.rep_name
      this.repEmail = this.item.repData?.rep_email
      this.repPhone = this.item.repData?.rep_phone
      this.sendToRep = this.item.repData?.send_to_rep
    } else {
      this.loading = false
    }
  },
  methods: {
    getAutocomplete() {
      return new Date().getTime().toString()
    },
    onBlur(type) {
      if (type === 'Login') {
        this.focusEmail = false
        return
      }
      if (type === 'Password') {
        this.focusPassword = false
      }
    },
    onFocus(type) {
      if (type === 'Login') {
        this.focusEmail = true
        return
      }

      if (type === 'Password') {
        this.focusPassword = true
      }
    },
    onClose() {
      this.$emit('closeDialogFormConnectDistributors')
    },
    async onFetchLoginPass(id) {
      try {
        const { data } = await this.$store.dispatch('jvZen/get', [
          `practice-location-distributors/${id}`,
          {},
        ])

        this.email = data.login
        this.password = data.password
      } catch (e) {
        console.error('onFetchLoginPass', e)
      } finally {
        this.loading = false
      }
    },
    onConnect() {
      const data = {
        login: this.email,
        password: this.password,
        repData: !this.addMyRep ? null : {
          rep_name: this.repName,
          rep_email: this.repEmail,
          rep_phone: this.repPhone,
          send_to_rep: this.sendToRep,
        },
        item: this.item,
      }
      if (this.valid) {
        this.$emit('onConnect', data)
      }
      this.errorEmail = this.$refs.email.valid === false
      this.errorPassword = this.$refs.password.valid === false
    },
  },
}
